type Params = {
  section?: string;
  subSection?: string;
  propertyId?: string;
};

export function getSidebarSelectedKey({
  section,
  subSection,
  propertyId,
}: Params) {
  return propertyId || (subSection && subSection !== 'properties')
    ? subSection
    : section;
}
